// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <detail-view
  :endpoint="endpoint + 'zones'"
  :hiddenValues="hiddenValues"
  name="Zone"
  parentRoute="zones"
  permissions="zones"
  :values="values"
  ></detail-view>
</template>
<script>
import { mapGetters } from 'vuex'

import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'
import Rules from 'vue-common/components/rules'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Description',
                value: 'description'
              },
              {
                name: 'Alert Time (minutes)',
                value: 'duration',
                type: 'duration',
                valueType: 'minutes'
              },
              {
                name: 'Emails',
                value: 'emails',
                type: 'combobox',
                width: 'xs12',
                multiple: true,
                rule: this.emailRule
              },
              {
                name: 'Delete Delay (hours)',
                value: 'killDuration',
                type: 'duration',
                valueType: 'hours'
              },
              {
                name: 'Delete Immediately',
                value: 'immediateKill',
                type: 'checkbox'
              },
              {
                name: 'Delete Behavior',
                value: 'killMode',
                type: 'select',
                context: ENDPOINT + 'killmodes',
                itemText: 'text',
                itemValue: 'value'
              }
            ]
          ]
        },
        {
          name: 'Configuration',
          items: [
            [
              {
                text: 'Gates',
                value: 'gates',
                type: 'component',
                component: 'zone-gates'
              }
            ]
          ]
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'selectedSite'
    ]),

    hiddenValues: function () {
      return [{
        path: 'site',
        value: this.selectedSite._id
      }]
    }
  },

  methods: {
    emailRule: function (addresses) {
      for (var i in addresses) {
        var o = Rules.email(addresses[i])
        if (o !== true) {
          return o
        }
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ZoneEdit.vue